import React from 'react';

export const EditAppointmentIcon: React.FC<sharedComponents.SvgIcon> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <path d="M17.55 3.75 19.5 5.7 7.2 18H5.25v-1.95l12.3-12.3Zm0-.75a.68.68 0 0 0-.525.225l-12.3 12.3a.68.68 0 0 0-.225.525v2.7h2.7a.68.68 0 0 0 .525-.225l12.3-12.3c.3-.3.3-.75 0-1.05l-1.95-1.95A.68.68 0 0 0 17.55 3Z" fill="#fff"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M3 20.625c0-.207.168-.375.375-.375h17.25a.375.375 0 0 1 0 .75H3.375A.375.375 0 0 1 3 20.625ZM15.11 5.36a.375.375 0 0 1 .53 0l2.25 2.25a.375.375 0 0 1-.53.53l-2.25-2.25a.375.375 0 0 1 0-.53Z" fill="#fff"/>
  </svg>
);
